import React, { useEffect, useState } from "react";

export default function MyWorkd({ myWorkAnimation }) {
  const [cssClassName, setCssClassName] = useState("overlaycontainer");

  useEffect(() => {
    if (myWorkAnimation) {
      return setCssClassName("overlaycontainer fadeIn");
    } else {
      setCssClassName("overlaycontainer");
    }
  }, [myWorkAnimation]);

  return (
    <div
      className={cssClassName}
      style={{ pointerEvents: myWorkAnimation ? "all" : "none" }}
    >
      <p>Works Section</p>
    </div>
  );
}
